import {API, graphqlOperation} from "aws-amplify";
import {FindUserQuery, GetUserEmailOrNullQuery, ListCollaboratorsQuery} from "../API";
import {CollaboratorList} from "../models/Collaboration/CollaboratorList";
import {Collaborator, isCollaboratorType} from "../models/Collaboration/Collaborator";
import {findUser, getUserEmailOrNull, listCollaborators} from "./queries";
import {applyCollaborators} from "./mutations";

export async function listMapCollaborators(map_id: string): Promise<Collaborator[]> {
    /* @see amplify/backend/function/listCollaborators/src/index.js */
    const listed = await API.graphql(graphqlOperation(
        listCollaborators, {
            mapId: map_id
        })
    ) as { data: ListCollaboratorsQuery };

    if (!listed.data.listCollaborators) {
        throw new Error('unexpected listCollaborators')
    }

    return listed.data.listCollaborators
        .map(c => c && isCollaboratorType(c.type) && new Collaborator(c.user, c.email, c.type))
        .filter((c): c is Collaborator => c instanceof Collaborator);
}

export async function findUserFromEmail(email: string): Promise<string | null> {
    const user = await API.graphql(graphqlOperation(
        findUser, {
            email: email
        })) as { data: FindUserQuery };

    return user.data.findUser ? user.data.findUser : null;
}

export async function applyMapCollaborators(map_id: string, collaborator_list: CollaboratorList): Promise<void> {
    await API.graphql(
        graphqlOperation(applyCollaborators, {
            mapId: map_id,
            collaborators: collaborator_list.toApplyCollaboratorsArray()
        })
    );
}

export async function getUserEmailOrNullFromUserId(user_id: string): Promise<string | null> {
    const user = await API.graphql(graphqlOperation(
        getUserEmailOrNull, {
            userId: user_id
        })) as { data: GetUserEmailOrNullQuery };

    return user.data.getUserEmailOrNull ? user.data.getUserEmailOrNull : null;
}
